// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconWalkIn = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 7.83A3.001 3.001 0 0011 2a3 3 0 00-1 5.83v.576L5.689 9.7l-1.15 4.026 1.923.55.85-2.974L10 10.494v3.84l6.2 8.266 1.6-1.2-5.8-7.733zM11 6a1 1 0 100-2 1 1 0 000 2"
    />,
    <path d="M14 9.25v2.5l1.758 1.318 2.938-.587-.392-1.962-2.061.413zM6.942 21.5l2.818-4.153 1.269 1.692-2.431 3.584z" />
  );
export default SvgIconWalkIn;
